import CrewList from "../pages/ForemenManagement/CrewList";
import React from "react";
import { Redirect } from "react-router-dom";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import ChangePwd from "../pages/Authentication/ChangePassword";
import Changepassword from "../pages/ChangePassword/ChangePassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import jhalist from "../pages/Dashboard/jhalist";


// Company Management 
import CompanyManagement from "../pages/CompanyManagement/";
import Add_company from "../pages/CompanyManagement/Add_company";
import Edit_company from "../pages/CompanyManagement/Edit_company";

// Organization Management
import OrganizationManagement from "../pages/OrganizationManagement/";
import Add_organization from "../pages/OrganizationManagement/Add_organization";
import Edit_organization from "../pages/OrganizationManagement/Edit_organization";

// Foremen Management
import ForemenManagement from "../pages/ForemenManagement/";
import Add_foreman from "../pages/ForemenManagement/Add_foreman";
import Edit_foreman from "../pages/ForemenManagement/Edit_foreman";

// Contract Management 
import ContractManagement from "../pages/ContractManagement/";
import Add_contract from "../pages/ContractManagement/Add_contract";
import Edit_contract from "../pages/ContractManagement/Edit_contract";

// Job Management 
import JobManagement from "../pages/JobManagement/";
import Add_job from "../pages/JobManagement/Add_job";
import Edit_job from "../pages/JobManagement/Edit_job";


//Form Management 
import SpecialEquipment from "../pages/FormManagement/SpecialEquipment";
import RulesToDigBy from "../pages/FormManagement/RulesToDigBy";



// Stky Management 
import Stky from "../pages/Stky/";
import Add_stky from "../pages/Stky/Add_stky";
import Edit_stky from "../pages/Stky/Edit_stky";



const authProtectedRoutes = [
  { path: "/dashboard", exact: true, component: Dashboard },
  { path: "/jhalist", exact: true, component: jhalist },
  { path: "/profile", exact: true, component: UserProfile },
  { path: "/changepassword", exact: true, component: Changepassword },


  // Company Management
  { path: "/company_management", component: CompanyManagement },
  { path: "/add_company", component: Add_company },
  { path: "/edit_company/:id", component: Edit_company },

  // Organization Management
  { path: "/organization_management", component: OrganizationManagement },
  { path: "/add_organization", component: Add_organization },
  { path: "/edit_organization/:id", component: Edit_organization },
  // Foremen Management
  { path: "/foremen_management", component: ForemenManagement },
  { path: "/add_foremen", component: Add_foreman },
  { path: "/edit_foremen/:id", component: Edit_foreman },
  { path: "/foremen/:id/crew", component: CrewList },

  // Contract Management
  { path: "/contract_management", component: ContractManagement },
  { path: "/add_contract", component: Add_contract },
  { path: "/edit_contract/:id", component: Edit_contract },

  // Job Management
  { path: "/job_management", component: JobManagement },
  { path: "/add_job", component: Add_job },
  { path: "/edit_job/:id", component: Edit_job },

  //Form management

  { path: "/rules-to-dig-by", component: RulesToDigBy },

    // Stky Management
  { path: "/stky", component: Stky },
  { path: "/add_stky", component: Add_stky },
  { path: "/edit_stky/:id", component: Edit_stky },

  { path: "/special-equipment", component: SpecialEquipment },


  { path: "/", exact: true, component: () => <Redirect to="/login" /> },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/change-password", component: ChangePwd },
];

export { authProtectedRoutes, publicRoutes };
